const options = {
    container: 'body',
    boundary: 'window',
}

export default {
    initAll() {
        $('[data-toggle="tooltip"]').tooltip(options)
    },

    init(el) {
        $(el).tooltip(options)
    },

    initChildrens(el) {
        $(el).find('[data-toggle="tooltip"]').tooltip(options)
    }
}
